import TablaConciliacion from "../../../TablaConciliacion";

function TablaDevimar() {
  return <TablaConciliacion nombreUseCase="devimar" titulo="DEVIMAR" />;
}

export default TablaDevimar;
